var _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCashGift = function SvgCashGift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M1.25.601h39v24h-39z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.8,
    d: "M12.25 4.701h18"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.75,
    y: 8.101,
    width: 9,
    height: 8.4,
    rx: 4,
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "bevel"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.8,
    d: "M12.25 19.101h18"
  })));
};
export default SvgCashGift;